// Initialize Lenis Smooth Scrolling
const lenis = new Lenis({
  duration: 1.2,
  easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), 
  direction: 'vertical', 
  gestureDirection: 'vertical', 
  smooth: true,
  mouseMultiplier: 1,
  smoothTouch: false,
  touchMultiplier: 2,
  infinite: false,
})

// Sync GSAP ScrollTrigger with Lenis
function raf(time) {
  lenis.raf(time)
  requestAnimationFrame(raf)
}
requestAnimationFrame(raf)

// Register GSAP plugins
gsap.registerPlugin(ScrollTrigger);

// Initial Setup
document.addEventListener("DOMContentLoaded", () => {
  initAnimations();
});

function initAnimations() {
  // 1. Fade Up Elements (Generic)
  gsap.utils.toArray(".fade-up").forEach(element => {
    gsap.from(element, {
      y: 60,
      opacity: 0,
      duration: 1,
      ease: "power3.out",
      scrollTrigger: {
        trigger: element,
        start: "top 85%",
        toggleActions: "play none none reverse"
      }
    });
  });

  // 2. Staggered Lists (Cards, Features)
  gsap.utils.toArray(".stagger-group").forEach(group => {
    const items = group.querySelectorAll(".stagger-item");
    gsap.from(items, {
      y: 40,
      opacity: 0,
      duration: 0.8,
      stagger: 0.15,
      ease: "power3.out",
      scrollTrigger: {
        trigger: group,
        start: "top 85%",
        toggleActions: "play none none reverse"
      }
    });
  });

  // 3. Counters
  gsap.utils.toArray(".counter").forEach(counter => {
    const target = parseFloat(counter.getAttribute("data-target"));
    const isDecimal = counter.getAttribute("data-target").includes(".");

    gsap.to(counter, {
      innerHTML: target,
      duration: 2.5,
      ease: "power2.out",
      snap: { innerHTML: isDecimal ? 0.1 : 1 },
      scrollTrigger: {
        trigger: counter,
        start: "top 90%",
        once: true
      },
      onUpdate: function() {
        if(isDecimal) {
            counter.innerHTML = Number(this.targets()[0].innerHTML).toFixed(1);
        }
      }
    });
  });

  // 4. Parallax Slow
  gsap.utils.toArray(".parallax-slow").forEach(layer => {
    gsap.to(layer, {
      yPercent: 15,
      ease: "none",
      scrollTrigger: {
        trigger: layer.parentElement,
        start: "top bottom",
        end: "bottom top",
        scrub: true
      }
    });
  });
}
